import get from 'lodash/get';
import some from 'lodash/some';
import Breadcrumb from '@Services/Breadcrumb';
import { socketErrorNumber, socketErrorPattern } from './ResultSetValidationConstants';

export function validateExistingBreadcrumbForResults({ databaseId, resultName } = {}) {
  return Breadcrumb.getBreadcrumbForDbByResultName(databaseId, resultName);
}

export function validateExistingBreadcrumbForHeatmap({ databaseId } = {}) {
  return Breadcrumb.getActiveBreadcrumbForDb(databaseId);
}

export function validateSocketError(response) {
  const { errorNumber, validationErrors = [] } = get(response, 'data', {});
  return errorNumber === socketErrorNumber && some(validationErrors, (err) => new RegExp(socketErrorPattern, 'gi').test(err));
}
